<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light my-navbar" v-if="isAuthenticated">
    <router-link :to="{ name: 'home' }" class="navbar-brand">SyBridge Checker</router-link>
    <div class="navbar-title mx-auto">
      <!-- {{projectName}} -->
      <div class="project-heading" v-if="project">
        <span class="navbar-project-name">{{ project ? project.name : '' }}</span>

        <span class="navbar-project-issues" v-if="project.status">
          <b-badge :variant="project.status.issue ? 'danger' : 'secondary'" @click="$emit('goto-issues', '')">{{project.status.issue}}</b-badge>
        </span>
        <span class="navbar-project-progress" v-if="project.status">
          {{project.status.accepted / project.status.count | numeral('0%')}}
          <b-progress height="6px" class="" :max="project.status.count">
            <b-progress-bar :value="project.status.accepted" variant="success"></b-progress-bar>
          </b-progress>
        </span>
      </div>
    </div>
  
    <ul class="navbar-nav">
      <li class="mx-1">
        <select class="form-control-sm" :value="selectedFacility" @change="$store.dispatch('changeFacility', $event.target.value)" :disabled="preventFacilityChange">
          <option v-if="isAdmin" :value="null">All Facilities</option>
          <option v-else disabled :value="null">-- SELECT FACILITY --</option>
          <option v-for="facility in activeFacilities" :key="facility.code" :value="facility.code">{{facility.name}}</option>
        </select>
      </li>
      <li>
        <select class="form-control-sm" :value="$i18n.locale" @change="$store.dispatch('changeLocale', {lang: $event.target.value, i18n: $i18n})">
          <option v-for="(lang) in langs" :key="lang.key" :value="lang.key">{{lang.value}}</option>
        </select>
      </li>
      <li class="nav-item py-1 px-2">
        Logged in as: <b>{{ profile.name }}</b>
      </li>
      <li class="nav-item">
        <button class="btn btn-sm btn-secondary" type="submit" @click.prevent="logout">{{ $t('nav.logout') }}</button>
      </li>
      <li class="nav-item ml-2" v-if="isAdmin">
        <router-link :to="{ name: 'admin-view' }" class="btn btn-sm btn-primary">{{ $t('nav.admin') }}</router-link>
      </li>
      <!--<li class="nav-item mx-2">
    <a class="btn btn-sm btn-outline-secondary"
       href="/swagger"
       target="_blank">{{$t('nav.swagger')}}</a>
  </li>-->

    </ul>

  </nav>
</template>

<script>
  import Vue from "vue";
  import { Vuex, mapGetters, mapState, mapActions, mapMutations } from "vuex";


  export default Vue.extend({
    name: "Navbar",
    data() {
      return {
        preventFacilityChange: false,
      };
    },
    computed: {
      ...mapState('context', ['profile']),
      ...mapGetters('context', ['isAuthenticated', 'isAdmin']),
      ...mapState(['selectedFacility', 'project']),
      ...mapGetters(['activeFacilities', 'langs', 'projectName']),
    },
    methods: {
      ...mapActions('context', ['logout'],),
      initializeFacilities() {
        this.$store.dispatch('fetchFacilities')
          .then(function (data) {
            this.$store.commit('setFacility', window.localStorage.getItem('facilityCode') || 'SY02M');
          }.bind(this));
      },
    },
    watch: {
      $route(to, from) {
        if (to.name == 'project') {
          this.preventFacilityChange = true;
        } else {
          this.preventFacilityChange = false;
        }
      }
    },
    created() {
      this.initializeFacilities();
    }
});
</script>
<style lang="scss">
.my-navbar {
  border-bottom: 1px solid #ddd;
}

.navbar-brand {
  font-weight: bold;
  font-size: 130%;
  &:hover {
    color: #0252bb !important;
  }
}
.navbar-title {
  flex-grow: 1;
  
  font-weight: bold;
  font-size: 115%;
  text-align: center;
}
.navbar-project-name,
.navbar-project-issues,
.navbar-project-progress{
  display: inline-block;
  margin: 0 0.35em;
}
.navbar-project-name,
.navbar-project-issues {
  position:relative;
  top: -0.4em;
}
.navbar-project-progress{
  width: 110px;
}
</style>
